import { Flex } from '@chakra-ui/react';
import useRuntimeStore from '../../stores/runtime-store';
import { DebugModal } from './DebugModal';
import Header from './Header';
import PipelineLockedIndicator from './PipelineLockedIndicator';
import PipelineSchema from './PipelineSchema';
import { StepDrawer } from './step-drawer/StepDrawer';
import { VarsModal } from './VarsModal';

const PipelineEditor: React.FC = () => {
    const { isLocked } = useRuntimeStore((state: any) => state);
    return (
        <>
            <VarsModal />
            <DebugModal />
            <StepDrawer />
            {isLocked && <PipelineLockedIndicator />}
            <Flex height={'100vh'} direction={'column'}>
                <Header />
                <PipelineSchema />
            </Flex>
        </>
    );
};

export default PipelineEditor;
